import { c as _c } from "react/compiler-runtime";
import { useCompatRouter } from "@website/hooks/compat-router";
import { LoginStepType, LoginUserDataType } from "@website/widget/login/login.types";
import { useEffect, useState } from "react";
export const useLogin = () => {
  const $ = _c(12);
  const router = useCompatRouter();
  let t0;
  if ($[0] !== router) {
    t0 = step => {
      router && router?.replace(router?.pathname, {
        ...router?.query,
        ["login_step"]: step
      }, {
        shallow: true,
        scroll: false
      });
    };
    $[0] = router;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const setStep = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      phoneNumber: "",
      userExists: false,
      hasPassword: false,
      accessToken: "",
      refreshToken: "",
      forgotPassword: false,
      message: "",
      otpLength: 0,
      otpValidUntil: 0,
      otpId: "",
      otp: ""
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const [userData, setUserData] = useState(t1);
  let t2;
  if ($[3] !== setStep || $[4] !== userData?.phoneNumber) {
    t2 = () => {
      if (!userData?.phoneNumber) {
        setStep("phone-number");
      }
    };
    $[3] = setStep;
    $[4] = userData?.phoneNumber;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = userData?.phoneNumber;
  let t4;
  if ($[6] !== t3) {
    t4 = [t3];
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  useEffect(t2, t4);
  const t5 = router?.query?.login_step as LoginStepType || "phone-number";
  let t6;
  if ($[8] !== setStep || $[9] !== t5 || $[10] !== userData) {
    t6 = {
      step: t5,
      setStep,
      userData,
      setUserData
    };
    $[8] = setStep;
    $[9] = t5;
    $[10] = userData;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};